import { required, maxLength, numeric, minLength } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    senha: { numeric, minLength: minLength(4), maxLength: maxLength(4) },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.description.maxLength && errors.push('Descrição não pode conter mais de 30 caracteres.')
    return errors
  },
  senhaErrors() {
    const errors = []
    if (!this.$v.form.senha.$dirty) return errors
    !this.$v.form.senha.numeric && errors.push('Formato inválido.')
    !this.$v.form.senha.minLength && errors.push('Senha deve possuir 4 caracteres.')
    !this.$v.form.senha.maxLength && errors.push('Senha deve possuir 4 caracteres.')
    return errors
  },
}
